// Acesso tipado a `window.__ETS_CONFIG__` — escrito pelo interceptor com base
// no `injection_config` do domínio. A declaração global de window.__ETS_CONFIG__
// vive em entry-lite.ts (tipada como AutoInitOptions); este arquivo adiciona os
// campos server-driven (auto_page, cookie_domain, features) como view compatível.
// loader_url e hash_salt são consumidos apenas pelo interceptor e não aparecem aqui.

export interface InjectionConfigClient {
  auto_page?: boolean;
  cookie_domain?: string;
  features?: Record<string, boolean>;
  [key: string]: unknown;
}

export function getInjectionConfigClient(): InjectionConfigClient {
  if (typeof window === "undefined") return {};
  return (window.__ETS_CONFIG__ ?? {}) as unknown as InjectionConfigClient;
}

export function getCookieDomainOverride(): string | undefined {
  const v = getInjectionConfigClient().cookie_domain;
  return typeof v === "string" && v.trim() ? v.trim() : undefined;
}

export function isAutoPageEnabled(defaultValue = true): boolean {
  const v = getInjectionConfigClient().auto_page;
  return typeof v === "boolean" ? v : defaultValue;
}

/** Lê uma feature flag. Retorna `defaultValue` se não estiver definida. */
export function getFeature(name: string, defaultValue = false): boolean {
  const features = getInjectionConfigClient().features;
  if (!features || typeof features !== "object") return defaultValue;
  const v = features[name];
  return typeof v === "boolean" ? v : defaultValue;
}

/** Retorna uma cópia do map de features (ou {} se não houver). */
export function getFeatures(): Record<string, boolean> {
  const features = getInjectionConfigClient().features;
  if (!features || typeof features !== "object") return {};
  const out: Record<string, boolean> = {};
  for (const [k, v] of Object.entries(features)) {
    if (typeof v === "boolean") out[k] = v;
  }
  return out;
}
